var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrategy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512.1 65.2L688 146c6.2 2.8 5.9 11.3-0.6 13.7L512.3 225l-0.2-159.8z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M521.3 321l-20-0.1 0.7-245.8c0-5.5 4.5-10 10-10s10 4.5 10 10l-0.7 245.9z",
    fill: "#8a8a8a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2 960.7v-614c0-14.8 12-26.7 26.7-26.7l136.1 0.2c14.7 0 26.7 12 26.7 26.7v101.3h153.8V346.9c0-14.8 12-26.7 26.7-26.7h146.5c14.8 0 26.7 12 26.7 26.7v101.3h159.7l1.5-101.9c0.2-14.6 12.1-26.3 26.7-26.3h138.2c14.7 0 26.7 11.9 26.7 26.7l1 612.9-897 1.1z",
    fill: "#8a8a8a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M620 959.6H403.4v-211c0-59.8 48.5-108.3 108.3-108.3S620 688.8 620 748.6v211z",
    fill: "#2c2c2c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategy);
export default __webpack_public_path__ + "static/media/strategy.00939cfd7df0976ad84bb127de649a6e.svg";
export { ForwardRef as ReactComponent };